import LoginForm from "../components/organisms/LoginForm";

/**
 * LoginPage - ログインページ
 * @param {function} onLogin - ログイン成功時のコールバック
 */
function LoginPage({ onLogin }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white rounded-2xl shadow-md p-10 h-96 w-1/4 min-w-80">
        <h1 className="text-lg font-bold text-center text-gray-800 mb-1">
          ゆふ小町テラステナント様専用サイト
        </h1>
        <h2 className="text-base text-center text-gray-600 mb-6">ログイン</h2>
        <LoginForm onLogin={onLogin} />
      </div>
    </div>
  );
}

export default LoginPage;
